// Stay-plan classification for a PNR group (mvp AccommodationTab parity). Only
// `hotel` groups need a room allocation; the others record why the group isn't
// being placed (waiting for a near-term flight, going home locally, or rebooked
// onto another carrier). This is operator-set UI state for the disruption
// workflow — there is no backend stay-plan field yet, so it lives in the UI.
//
// Shared across both allocation scopes (event / single-case) —
// see docs/ui/reusable-allocation-components.plan.md.
//
// Copy lives in i18n under the `cases` namespace (`stayPlan.*`); this file holds
// KEYS, never language — the rendering component calls `t()`.

export type StayPlanType = 'hotel' | 'waiting_at_airport' | 'going_home' | 'another_airline';

/** i18n key of the full select-option label. */
export const STAY_PLAN_LABEL_KEY: Record<StayPlanType, string> = {
  hotel: 'stayPlan.label.hotel',
  waiting_at_airport: 'stayPlan.label.waitingAtAirport',
  going_home: 'stayPlan.label.goingHome',
  another_airline: 'stayPlan.label.anotherAirline',
};

/** i18n key of the short chip label. */
export const STAY_PLAN_SHORT_KEY: Record<StayPlanType, string> = {
  hotel: 'stayPlan.short.hotel',
  waiting_at_airport: 'stayPlan.short.waitingAtAirport',
  going_home: 'stayPlan.short.goingHome',
  another_airline: 'stayPlan.short.anotherAirline',
};

export const STAY_PLAN_ORDER: StayPlanType[] = [
  'hotel',
  'waiting_at_airport',
  'going_home',
  'another_airline',
];

export const DEFAULT_STAY_PLAN: StayPlanType = 'hotel';
